// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"febf866f","64":"6c47783c","104":"96628530","205":"dc4168c9","394":"49ddb7d4","592":"da864470","672":"cf00cb05","740":"fec7b56b","835":"0eb7127c"}[chunkId] + ".chunk.js";
};